import { grommet as baseTheme } from 'grommet'

import { colors, newColors } from './colors'
import { above, below } from './screen-sizes'
import { newSpaces } from './spaces'
import { getTypography, typography } from './typography'

export { SCREEN_SIZES } from './screen-sizes'

export {
  Container,
  NormalizedWrapper,
  ThemeProvider,
  PageContent,
  ImageContainer,
  NormalizedContainer,
} from './common-components'

export const theme = {
  name: 'Light',
  ...baseTheme,
  above,
  below,
  /** deprecated. Необходимо использовать newSpaces */
  spaces: [0, 4, 8, 16, 32, 64, 128, 158, 256, 280],
  /** deprecated. Необходимо использовать typography */
  fontSizes: [
    12, 14, 16, 20, 24, 32, 40, 56, 72, 80, 100, 120, 36, 28, 18, 30, 26, 22,
    47, 60,
  ],
  /** deprecated. Необходимо использовать typography */
  fontWeight: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  maxWidth: [200, 240, 320, 998, 1440, 540, 1360],
  lineHeight: [26, 30, 34, 45, 20, 36, 18, 24, 58, 142],
  /** deprecated. Необходимо использовать newColors */
  colors,
  newColors,
  typography,
  getTypography,
  newSpaces,
} as const

export type Styles = typeof theme
